module.exports = __webpack_public_path__ + "img/default_concreted.b31b68fe.png";